import { render } from "./UiRejectReason.vue?vue&type=template&id=1c8f6f2c"
import script from "./UiRejectReason.vue?vue&type=script&lang=js"
export * from "./UiRejectReason.vue?vue&type=script&lang=js"

import "./UiRejectReason.vue?vue&type=style&index=0&id=1c8f6f2c&lang=scss"

import exportComponent from "/home/runner/work/studyflow-frontend/studyflow-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__